export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Totale da detrarre"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Commissione"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Info"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Da accreditare"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impossibile calcolare l'importo"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fondi insufficienti per il pagamento"])}
}